import { render, staticRenderFns } from "./UserTypesView.vue?vue&type=template&id=9b75c888&scoped=true"
import script from "./UserTypesView.vue?vue&type=script&lang=js"
export * from "./UserTypesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b75c888",
  null
  
)

export default component.exports